import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Input } from '@angular/core';

import { GlobalDataService } from '@providers/global-data/global-data.service';
import { GlobalFunctionService } from '@providers/global-function/global-function.service';
import { RequestService } from '@providers/request/request.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';

@Component({
  selector: 'app-chapter',
  templateUrl: './chapter.component.html',
  styleUrls: ['./chapter.component.less']
})
export class ChapterComponent {
  @Input() chapter: any;
  @Input() quotationId: any;
  @Input() versionId: any;
  @Input() quotation: any;
  @Input() project:any;

  public services: any;

  public isMobile: boolean = false;
  public isServiceLoaded:boolean = false;

  constructor(
    private requestService: RequestService,
    breakpointObserver: BreakpointObserver,
    public globalFunction: GlobalFunctionService,
    private requestV2Service: RequestV2Service,
    public globalDataService: GlobalDataService
  ) {
    breakpointObserver.observe(['(min-width: 800px)']).subscribe((result) => {
      this.isMobile = result.matches;
    });
  }

  public calculateTotalChapterPrice(): number {
    if (this.globalDataService) {
      const findChapter = this.globalDataService.financial.customer.chapters
        .find(i => i.id_quotation_chapter === this.chapter.id);

      if (findChapter) {
        return findChapter.total;
      }
    }

    return 0;
  }

  public async openChapter() {
    const servicesResult = await this.requestV2Service.getServices(this.chapter.id);
    this.services = servicesResult.items;
    this.isServiceLoaded = true;
  }
}
